export type Params = {
  pathname: string;
  exact?: boolean;
};

export abstract class PageTags {
  static get(params: Params): string[] | undefined {
    return undefined;
  }
}
